//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import {getFileName} from "@/util";
import GiftCardControls from "@/components/shop/conf/GiftCardControls";
import UiPropertyCard from "~/components/Ui/UiPropertyCard.vue";
import UiPropertyGrid from "~/components/Ui/UiPropertyGrid.vue";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon_24.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon_24.vue";
import CloseIcon_24 from "@/components/icons/CloseIcon_24.vue";
import DragIcon_24 from "@/components/icons/DragIcon_24.vue";
import Engraving from "./Engraving.vue";
import EditStone from "./EditStone";
import Pendants from "./Pendants";
import PendantChoice from "./PendantChoice";

export default {
  components: {
    UiPropertyGrid,
    UiPropertyCard,
    GiftCardControls,
    draggable,
    ChevronUpIcon,
    ChevronDownIcon,
    CloseIcon_24,
    DragIcon_24,
    Engraving,
    EditStone,
    Pendants,
    PendantChoice,
  },
  props: {
    productTypeLabel: {
      type: String,
      default: 'product'
    },
    total: {
      type: String,
      default() {
        return '0'
      }
    },
    selected: {
      type: Object,
      default() {
        return {}
      }
    },
    engraving: {
      type: Object,
      default() {
        return {}
      }
    },
    inlayList: {
      type: Array,
      default: () => ([])
    },
    embossing: {
      type: String,
      default() {
        return ''
      }
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    stoneTypes: {
      type: Array,
      default() {
        return []
      }
    },
    stoneShapes: {
      type: Array,
      default() {
        return []
      }
    },
    typeMaterial: {
      type: Array,
      default() {
        return []
      }
    },
    boxColor: {
      type: Array,
      default() {
        return []
      }
    },
    mt: {
      type: String,
      default() {
        return ''
      }
    },
    onlyStoneTypeThemesGroup: {
      type: Boolean,
      default: false
    },
    // Configurator
    totalWithSale: {
      type: String,
      default() {
        return '0'
      }
    },
    url: {
      type: String,
      default: ''
    },
    views: {
      type: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    watchVisible: {
      type: Boolean,
      default: false
    },
    s: {
      type: String,
      default() {
        return ''
      }
    },
    sizes: {
      type: Array,
      default() {
        return []
      }
    },
    isGiftCard: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    // Configurator
    activePendants: {
      type: Array,
      default() {
        return []
      }
    },
  },
  inject: [
    'productAnimate',
    'giftCardData',
  ],
  watch: {
    mt() {
      this.metal = this.mt;
    },
    metal(n, o) {
      this.changeM()
    },
    // Configurator
    s() {
      this.size = this.s;
    },
    size() {
      this.changeS()
    },
    visible() {
      this.$emit('isVisible', this.visible)
    },
    'giftCardData.giftcard_amount'(val) {
      if(val) {
        this.amountError = false;
        this.giftCardExpansionPanels = null;
      }
    },
    // Configurator
  },
  data() {
    return {
      metal: this.mt,
      // Configurator
      expansionPanels: null,
      expansionPanels1: null,
      emailSuccess: false,
      confirmMessage: null,
      confirmErrMessage: null,
      email: '',
      saveModal: false,
      loadingSave: false,
      visible: true,
      showMetals: false,
      showSizes: false,
      size: this.s,
      sizeError: false,
      amountError: false,
      giftCardExpansionPanels: null,
      // Configurator
      stoneExpansionPanels: null,
      pendantExpansionPanels: null,
    }
  },
  mounted() {
    this.$on('editStone', this.editStone)
    // Configurator
    if (this.watchVisible) {
      const el = this.$el;
      document.addEventListener('scroll', () => {
        this.visible = el.getBoundingClientRect().y + el.getBoundingClientRect().height >= 0;
      })
    }
    if (this.info.has_orientation && this.info.request_config?.length === 1 && !this.$route.query.orientation) {
      this.switchProductOrientation('right');
    }
    // Configurator
  },
  methods: {
    getFileName,
    sortImages(images) {
      const imagesN = {}
      for (const k in images) {
        let a = k.replace(/^\D+/g, '');
        a = Number(a);
        imagesN[a] = images[k]
      }
      const sorted = Object.keys(imagesN).sort().reduce(
          (obj, key) => {
            obj[key] = imagesN[key];
            return obj;
          },
          {}
      );
      const arr = [];
      for (const i in sorted) {
        arr.push(sorted[i])
      }
      return arr
    },
    changeInlay(item) {
      let temp = this.$route.query.configId.split(',').filter((el, i) => i);
      const connectedConfigurationsLength = temp?.length;
      let arr = this.$route.query.configId.split(',')[0].split('-');
      arr[2] = arr[2] !== item.value ? item.value : arr[2]
      arr = arr.join('-');
      temp = temp.join(',');

      if (this.info.dividable_pair && this.info.request_config?.length === 2) {
        temp = arr;
      }

      const query = {...this.$route.query, configId: arr + (connectedConfigurationsLength ? ',' : '') + temp};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    editStone(index) {
      this.$parent.$emit('editStone', index)
    },
    selectedProduct(el) {
      let arr = el.configuration_id.split('-');

      const stones = [];

      const attr = []

      for (const key in this.bootstrap.data.attributes) {
        attr.push(this.bootstrap.data.attributes[key])
      }

      const stoneTypes = [attr.filter(item => item.group_id === 3).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.group_id === 9).map(item => {
        return {...item, title: item.name}
      })];
      const stoneShapes = [attr.filter(item => item.group_id === 4 || item.group_id === 11).map(item => {
        return {...item, title: item.name}
      }), attr.filter(item => item.group_id === 5).map(item => {
        return {...item, title: item.name}
      })];

      const symbols = attr.filter(item => item.group_id === 11).map(item => {
        return {...item, title: item.name}
      });
      arr.forEach((item, i) => {
        if (i && i < (arr.length - 1)) {
          const a = {};
          if (stoneShapes[0]
              && stoneShapes[0].some(item => item.sku_part === arr[i].substr(0, 2))) {
            a.ss = stoneShapes.find(item => item.sku_part === arr[i].substr(0, 2))
          } else if (symbols && symbols.some(item => item.sku_part === arr[i])) {
            a.ss = symbols.find(item => item.sku_part === arr[i])
          }
          if (stoneTypes[0]
              && stoneTypes[0].some(item => item.sku_part === arr[i].substr(2))) {
            a.st = stoneTypes[0].find(item => item.sku_part === arr[i].substr(2))
          } else if (symbols && symbols.some(item => item.sku_part === arr[i])) {
            a.st = symbols.find(item => item.sku_part === arr[i])
          }
          stones.push(a)
        }
      })
      return {
        stones,
        m: this.typeMaterial.find(item => item.value === arr[arr.length - 1])
      }
    },
    changeBail(item) {
      if (!item) {
        this.productAnimate.forcedShow = true;
      }
      let temp = this.$route.query.configId.split(',');
      temp[1] = item ? item.configuration_id : '';
      temp = temp.join(',');
      const query = {...this.$route.query, configId: temp};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
    },
    changeST(item) {
      let temp = this.$route.query.configId.split(',').filter((el, i) => i);
      const connectedConfigurationsLength = temp?.length;
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let sizes = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      });
      let index = sizes.length ? 2 : 1;
      arr.forEach((it, i) => {
        if (i && i < (arr.length - index) && i === (0 + 1)) {
          if (this.onlyStoneTypeThemesGroup) {
            arr[i] = item.value;
          } else if (arr[i].substr(2) !== item.value) {
            arr[i] = arr[i].substr(0, 2) + item.value;
          }
        }
      })
      arr = arr.join('-');
      temp = temp.join(',');

      if (this.info.dividable_pair && this.info.request_config?.length === 2) {
        temp = arr;
      }

      const query = {...this.$route.query, configId: arr + (connectedConfigurationsLength ? ',' : '') + temp};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query}).catch(err => {});
      }
    },
    addAnElement() {
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let first = arr.findIndex(item => item === "");
      arr[first] = 'RD' + this.stoneTypes[0][0].value;
      const query = {...this.$route.query, configId: arr.join('-')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
      this.$nextTick(() => {
        this.configuration('MileElements', first - 1);
      })
    },
    addAPendant() {
      let arr = this.$route.query.configId.split(',');
      let first = arr.findIndex(item => item === "");
      arr[first] = this.info.connected_products[0].default_config.configuration_id;
      if (this.info.connected_products[0].connected_configs && this.info.connected_products[0].connected_configs.bail && this.info.connected_products[0].connected_configs.bail.length) {
        arr[first] = `${arr[first]}|${this.info.connected_products[0].connected_configs.bail[0].configuration_id}`
      }
      const query = {...this.$route.query, configId: arr.join(',')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
      // this.$nextTick(() => {
      //   this.configuration('PendantChoice', first - 1);
      // })
    },
    removeItem(ind, e) {
      e.stopPropagation();
      e.preventDefault();
      let arr = this.$route.query.configId.split(',')[0].split('-');
      arr[ind + 1] = '';
      const query = {...this.$route.query, configId: arr.join('-')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
    },
    removeProduct(ind) {
      if (this.productAnimate.status) {
        return;
      }
      this.productAnimate.forcedShow = true;
      const urlProductsIdList = this.$route.query.configId.split(',');
      urlProductsIdList[ind + 1] = '';
      const query = {...this.$route.query, configId: urlProductsIdList.join(',')};
      if (this.$route.query.configId !== query) {
        const pendantEngravingIndex = ind + 1;
        delete query[`e${pendantEngravingIndex}_sub`];
        delete query[`f${pendantEngravingIndex}_sub`];
        this.$router.replace({query});
      }
    },
    // close() {
    //   this.$parent.$emit('changeStage', 'configurator')
    // },
    back() {
      this.$parent.$emit('changeStage', 'configurator')
    },
    configuration(stage, index = null) {
      this.$parent.$emit('changeStage', stage);
      this.$emit('changeStage', stage);
      if (index !== null) {
        this.$parent.$emit('editStone', index);
      }
      this.metal = this.mt;
      this.size = this.s;
    },
    changeM() {
      this.$parent.$emit('changeMetal', this.metal)
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let sizes = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      });
      let index = sizes.length ? 2 : 1;
      if (arr[arr.length - index] !== this.metal) {
        // arr[arr.length - index] = this.metal;
        let c = this.$route.query.configId.split('-');
        c = c.map(item => {
          if (item.includes('|')) {
            let a = item.split('|')
            a = a.map(i => {
              return i === arr[arr.length - index] ? this.metal : i;
            })
            item = a.join('|');
          }
          if (item.includes(',')) {
            let a = item.split(',')
            a = a.map(i => {
              return i === arr[arr.length - index] ? this.metal : i;
            })
            item = a.join(',');
          }
          return item === arr[arr.length - index] ? this.metal : item;
        })
        c = c.join('-');
        // c = this.$route.query.configId.replaceAll(arr[arr.length - index], this.metal)
        const query = {...this.$route.query, configId: c};
        this.$router.replace({query});
      }
    },
    // Configurator
    getFormattedSizeValue(value) {
      if (typeof value === 'number' || value.search('LEN') === -1) {
        return Number(value);
      }
      const sizeDefiningNumber = this.isNecklaceThemesGroup ? 100 : 10;
      value = value.replace('LEN', '');
      value = Number(value);
      if (value < sizeDefiningNumber) {
        value *= 10;
      }
      return value;
    },
    productPairSingleToggle(pair) {
      if (this.loading || !this.info.request_config?.length) {
        return;
      }
      const configId = this.info.request_config[0].configuration_id;
      const query = {
        ...this.$route.query,
        configId: pair ? `${configId},${configId}` : configId
      };
      if (this.info.has_orientation) {
        query.orientation = !pair ? 'right' : [];
      }
      if (this.$route.query.configId !== query.configId) {
        this.$router.replace({query});
      }
    },
    switchProductOrientation(orientation) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          orientation: orientation
        }
      });
    },
    customizePressed() {
      const params = {
        cart_unique_id: this.$store.getters.getCartId,
        product_id: this.info.id,
        configuration_sku: this.$route.query.configId,
        page_url: window.location.href
      }
      this.$axios.post('/events/customize-pressed', params, {headers: {'Authorization': this.userInfo ? `Bearer ${this.userInfo.access_token.token}` : null}})
        .then(res => {
          console.log('send event success', res);
        })
        .catch(error => {
          console.log('send event error', error);
        })
    },
    sizeChanged(val) {
      this.sizeError = false;
      this.expansionPanels = null;

      if (this.$route.query.size === "default" && this.size === val) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            size: undefined
          }
        });
        return;
      }

      this.$parent.$emit('sizeChanged', val)
      let params = this.$route.query;
      if (params.size) {
        delete params.size
      }
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return false;
        } else {
          const params = {
            email: this.email,
            link: window.location.href
          }
          this.$axios.post('/products/link-to-email', params)
            .then(res => {
              fbq('track', 'Lead');
              this.emailSuccess = this.$t('youHaveGotMail');
            })
            .catch(err => {
              const temp = {};
              err.response.data.errors.forEach(item => {
                if (item.code === 400) {
                  temp[item.property] = [item.message]
                }
              })
              this.$refs.form.setErrors(temp);
            })
        }
      })
    },
    pendantSortImages(images) {
      const imageNumbers = {};
      for (const key in images) {
        let indexKey = key.replace(/^\D+/g, '');
        imageNumbers[Number(indexKey)] = images[key];
      }
      const sorted = Object.keys(imageNumbers).sort().reduce(
        (obj, key) => {
          obj[key] = imageNumbers[key];
          return obj;
        },
        {}
      );
      const arr = [];
      for (const key in sorted) {
        arr.push(sorted[key]);
      }
      return arr;
    },
    saveModalClose() {
      this.saveModal = false;
      this.email = null;
      this.emailSuccess = false;
      this.$refs.form.reset();
    },
    async addToBag() {
      if(this.isGiftCard) {
        if(!this.giftCardData.giftcard_amount) {
          this.giftCardExpansionPanels = 0;
          this.amountError = true;
        }
        const giftCardForm = this.$refs?.giftCardControls?.$refs?.giftCardForm?.$refs?.form;
        if(giftCardForm) {
          const validateResult = await giftCardForm.validate();
          if(!validateResult || !this.giftCardData.giftcard_amount) {
            return;
          }
        }
      }
      if (this.$route.query && this.$route.query.size && this.$route.query.size === 'default') {
        this.expansionPanels = (this.hasPendants && this.info.connected_products?.length) || this.info.engraving_upload || this.info.embossing ? 1 : 0;
        this.sizeError = true;
        this.$refs?.sizeControls?.scrollIntoView({ block: "center" });
        return;
      }
      this.$parent.$emit('addToBag');
    },
    openItems(e) {
      this[e] = !this[e];
    },
    closeMetals() {
      this.showMetals = false;
    },
    closeSizes() {
      this.showSizes = false;
    },
    changeS() {
      this.showSizes = false;
      let temp = this.$route.query.configId.split(',').filter((el, i) => i);
      let arr = this.$route.query.configId.split(',')[0].split('-');
      if (arr[arr.length - 1] !== this.size) {
        arr[arr.length - 1] = this.size;
        arr = arr.join('-');
        temp = temp.join(',');
        const query = {...this.$route.query, configId: arr + (temp ? ',' : '') + temp};
        this.$router.replace({query});
      }
    },
    openDrawer(type) {
      this.$parent.$emit('openDrawer', {type});
      this.$emit('openDrawer', {type});
    },
    // Configurator

    swapPendants(event) {
      if (this.productAnimate.status || event.oldIndex === event.newIndex) {
        return;
      }
      this.productAnimate.forcedShow = true;
      const urlProductsIdList = this.$route.query.configId.split(',');
      const oldIndex = this.pendants[event.oldIndex].urlIndex + 1;
      const newIndex = this.pendants[event.newIndex].urlIndex + 1;
      [urlProductsIdList[oldIndex], urlProductsIdList[newIndex]] = [urlProductsIdList[newIndex], urlProductsIdList[oldIndex]];
      const query = {...this.$route.query, configId: urlProductsIdList.join(',')};
      if (this.$route.query.configId !== query.configId) {
        const oldEngravingText = query[`e${oldIndex}_sub`];
        const oldEngravingFont = query[`f${oldIndex}_sub`];
        const newEngravingText = query[`e${newIndex}_sub`];
        const newEngravingFont = query[`f${newIndex}_sub`];
        delete query[`e${oldIndex}_sub`];
        delete query[`f${oldIndex}_sub`];
        delete query[`e${newIndex}_sub`];
        delete query[`f${newIndex}_sub`];
        if (newEngravingText || newEngravingFont) {
          query[`e${oldIndex}_sub`] = newEngravingText;
          query[`f${oldIndex}_sub`] = newEngravingFont;
        }
        if (oldEngravingText || oldEngravingFont) {
          query[`e${newIndex}_sub`] = oldEngravingText;
          query[`f${newIndex}_sub`] = oldEngravingFont;
        }
        this.$router.replace({query});
      }
    },
  },
  computed: {
    pendants: {
      set(value) {},
      get () {
        return this.activePendants;
      }
    },
    showPendants() {
      return (this.info.theme.id === this.constProductThemes().necklaceMain
        || this.info.theme.id === this.constProductThemes().braceletMain
        || this.info.theme.id === this.constProductThemes().beadBracelet
        || this.info.theme.id === this.constProductThemes().chainBracelet) && this.products?.length;
    },
    showPackageButton() {
      return this.info?.package?.types?.length &&
        (this.info.theme.id !== this.constProductThemes().pendantMain && this.info.theme.id !== this.constProductThemes().pendantSimple && this.info.theme.id !== this.constProductThemes().initialPendant);
    },
    bootstrap() {
      return this.$store.getters.getBootstrap;
    },
    box() {
      let box = '';
      if (this.info.theme.id === this.constProductThemes().package) {
        box = this.boxColor.find(item => item.value === this.$route.query.configId.split('-')[1]) || '';
      } else {
        box = this.boxColor.find(item => item.name === this.$route.query.bc) || '';
      }
      return {
        text: this.$route.query.bt || '',
        box: box,
      }
    },
    products() {
      return this.$route.query.configId.split(',').filter((item, i) => i)
    },
    addedProducts() {
      return this.$route.query.configId.split(',').filter((item, i) => i && item).length
    },
    // Configurator
    embossingLength() {
      return this.info.embossing_length || 6;
    },
    isRingThemesGroup() {
      return this.info.theme.id === this.constProductThemes().ringMain ||
        this.info.theme.id === this.constProductThemes().ringDuo ||
        this.info.theme.id === this.constProductThemes().ringMilestone ||
        this.info.theme.id === this.constProductThemes().ringBrand ||
        this.info.theme.id === this.constProductThemes().ringInitial ||
        this.info.theme.id === this.constProductThemes().ringInitialNoPave ||
        this.info.theme.id === this.constProductThemes().ringStoneMetalSize ||
        this.info.theme.id === this.constProductThemes().ringMetalStoneInlay ||
        this.info.theme.id === this.constProductThemes().ringSimple;
    },
    isBraceletThemesGroup() {
      return this.info.theme.id === this.constProductThemes().braceletMain ||
        this.info.theme.id === this.constProductThemes().braceletDuo ||
        this.info.theme.id === this.constProductThemes().chainBracelet ||
        this.info.theme.id === this.constProductThemes().beadBracelet ||
        this.info.theme.id === this.constProductThemes().braceletMilestone ||
        this.info.theme.id === this.constProductThemes().beadBraceletWithNoMetal;
    },
    isNecklaceThemesGroup() {
      return this.info.theme.id === this.constProductThemes().necklaceMain ||
        this.info.theme.id === this.constProductThemes().initialCharmChained ||
        this.info.theme.id === this.constProductThemes().pendantStoneMetalChained ||
        this.info.theme.id === this.constProductThemes().beadNecklace;
    },
    standardSizeInitialValue() {
      return this.getFormattedSizeValue(this.info.default_length_attribute.sku_part);
    },
    isRingSizerInCart() {
      return this.info.vendor_model === this.$store.getters.getRingSizerVendorModel && this.$store.getters.getCartItems?.some(item => item.configuration_id === this.$store.getters.getRingSizerVendorModel);
    },
    hasValentinesDaySale() {
      return this.info.sale && this.info.sale.code === 'VDAY'
    },
    pendantsDescription() {
      if (!this.pendants.length) {
        return;
      }
      const namesList = [];
      this.pendants.forEach(item => {
        if (!namesList.includes(item.product_title)) {
          namesList.push(item.product_title);
        }
      })
      if (namesList.length > 1) {
        namesList[namesList.length - 1] = `and ${namesList[namesList.length - 1]}`;
      }
      const descriptionLastPart = this.pendants.length > 1 ? 'Pendants' : 'Pendant';
      let joinedNames = namesList.join(', ');
      joinedNames = joinedNames.replace(', and', ' and');
      joinedNames = joinedNames.replaceAll(' Pendant', '');
      joinedNames = joinedNames.replaceAll(' Element', '');
      return `With ${joinedNames} ${descriptionLastPart}`;
    },
    hasPendants() {
      let result = false;
      switch (this.info.theme.id) {
        case this.$productServiceData.productThemesList.necklaceMain:
          result = true;
          break;
        case this.$productServiceData.productThemesList.beadNecklace:
          result = true;
          break;
        case this.$productServiceData.productThemesList.chainBracelet:
          result = true;
          break;
        case this.$productServiceData.productThemesList.beadBracelet:
          result = true;
          break;
      }
      return result;
    },
    showBraceletSizeHelp() {
      let result = false;
      switch (this.info.vendor_model) {
        case 'SOBRCABO':
          result = true;
          break;
        case 'SOBRMST':
          result = true;
          break;
        case 'SOBRDUO':
          result = true;
          break;
      }
      return this.info.category_code === 'bracelets' && result;
    },
    // Configurator
  },
}
